import { render, staticRenderFns } from "./DriverConfigProvince.vue?vue&type=template&id=ba8b2032&scoped=true"
import script from "./DriverConfigProvince.vue?vue&type=script&lang=js"
export * from "./DriverConfigProvince.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8b2032",
  null
  
)

export default component.exports